$(function () {
    const tabsBlock = $('.tabs-block');
    const tabsSelect = $('.tabs-select');
    const tabs = $(tabsBlock).find('.tab');
    const tabContent = $('.contents-table').find('.tab-content');

    $(tabsBlock)
        .find('.tab')
        .on('click', function (e) {
            e.preventDefault();
            const target = $(this).attr('href');
            $(tabs).removeClass('current');
            $(this).addClass('current');
            $(tabContent).hide();
            $(target).fadeIn('fast');
        });

    $(tabsSelect).on('change', function (e) {
        e.preventDefault();
        const target = $(this).val();
        $(tabs).removeClass('current');
        $(this).addClass('current');
        $(tabContent).hide();
        $(target).fadeIn('fast');
    });

    const gloriaUnit = 'NOSSA SENHORA DA GLÓRIA (SE)';
    const unitSelect = $('#law-unit');
    const unitExtras = $('.law-unit-extra, .law-unit-full');

    function applyLawUnit() {
        unitExtras.toggleClass('hidden', unitSelect.val() === gloriaUnit);
    }

    unitSelect.on('change', applyLawUnit);
    applyLawUnit();
});
